import { Breakpoint } from 'shared/types/Breakpoint'
import { BreakpointConfig } from 'shared/types/BreakpointConfig'

export const DEFAULT_BREAKPOINTS: BreakpointConfig = {
    xs: 0,      // Extra small devices (portrait phones)
    sm: 576,    // Small devices (landscape phones)
    md: 768,    // Medium devices (tablets)
    lg: 992,    // Large devices (desktops)
    xl: 1200,   // Extra large devices (large desktops)
    xxl: 1400,  // Extra extra large devices
}

// Common device breakpoint groups
export const DEVICE_GROUPS = {
    mobile: ['xs', 'sm'] as Breakpoint[],
    tablet: ['md'] as Breakpoint[],
    desktop: ['lg', 'xl', 'xxl'] as Breakpoint[],
}